// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IRequisitesDto } from './IRequisitesDto';
import {
    IRequisitesDtoFromJSON,
    IRequisitesDtoFromJSONTyped,
    IRequisitesDtoToJSON,
    IRequisitesDtoToJSONTyped,
} from './IRequisitesDto';
import type { IPaymentMethodOwnerDto } from './IPaymentMethodOwnerDto';
import {
    IPaymentMethodOwnerDtoFromJSON,
    IPaymentMethodOwnerDtoFromJSONTyped,
    IPaymentMethodOwnerDtoToJSON,
    IPaymentMethodOwnerDtoToJSONTyped,
} from './IPaymentMethodOwnerDto';
import type { IPaymentAddressResponseDto } from './IPaymentAddressResponseDto';
import {
    IPaymentAddressResponseDtoFromJSON,
    IPaymentAddressResponseDtoFromJSONTyped,
    IPaymentAddressResponseDtoToJSON,
    IPaymentAddressResponseDtoToJSONTyped,
} from './IPaymentAddressResponseDto';

/**
 * 
 * @export
 * @interface IPaymentMethodResponseDto
 */
export interface IPaymentMethodResponseDto {
    /**
     * 
     * @type {number}
     * @memberof IPaymentMethodResponseDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof IPaymentMethodResponseDto
     */
    payment_method_type?: IPaymentMethodResponseDtoPaymentMethodTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof IPaymentMethodResponseDto
     */
    is_default?: boolean;
    /**
     * 
     * @type {number}
     * @memberof IPaymentMethodResponseDto
     */
    account_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IPaymentMethodResponseDto
     */
    payment_method_status?: IPaymentMethodResponseDtoPaymentMethodStatusEnum;
    /**
     * 
     * @type {IPaymentMethodOwnerDto}
     * @memberof IPaymentMethodResponseDto
     */
    payment_method_owner?: IPaymentMethodOwnerDto;
    /**
     * 
     * @type {IRequisitesDto}
     * @memberof IPaymentMethodResponseDto
     */
    requisites?: IRequisitesDto;
    /**
     * 
     * @type {number}
     * @memberof IPaymentMethodResponseDto
     */
    recipient_id?: number;
    /**
     * 
     * @type {IPaymentAddressResponseDto}
     * @memberof IPaymentMethodResponseDto
     */
    payment_address?: IPaymentAddressResponseDto;
    /**
     * 
     * @type {string}
     * @memberof IPaymentMethodResponseDto
     */
    activation_status?: IPaymentMethodResponseDtoActivationStatusEnum;
}

/**
* @export
* @enum {string}
*/
export enum IPaymentMethodResponseDtoPaymentMethodTypeEnum {
    DIRECT_DEPOSIT = 'DIRECT_DEPOSIT',
    DEBIT = 'DEBIT',
    VENMO = 'VENMO',
    PAYPAL = 'PAYPAL',
    CHECK = 'CHECK'
}
/**
* @export
* @enum {string}
*/
export enum IPaymentMethodResponseDtoPaymentMethodStatusEnum {
    VERIFIED = 'VERIFIED',
    PENDING_VERIFICATION = 'PENDING_VERIFICATION',
    VERIFICATION_FAILED = 'VERIFICATION_FAILED',
    NEW = 'NEW'
}
/**
* @export
* @enum {string}
*/
export enum IPaymentMethodResponseDtoActivationStatusEnum {
    ACTIVE = 'ACTIVE',
    DELETED = 'DELETED'
}


/**
 * Check if a given object implements the IPaymentMethodResponseDto interface.
 */
export function instanceOfIPaymentMethodResponseDto(value: object): value is IPaymentMethodResponseDto {
    return true;
}

export function IPaymentMethodResponseDtoFromJSON(json: any): IPaymentMethodResponseDto {
    return IPaymentMethodResponseDtoFromJSONTyped(json, false);
}

export function IPaymentMethodResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IPaymentMethodResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'payment_method_type': json['payment_method_type'] == null ? undefined : json['payment_method_type'],
        'is_default': json['is_default'] == null ? undefined : json['is_default'],
        'account_id': json['account_id'] == null ? undefined : json['account_id'],
        'payment_method_status': json['payment_method_status'] == null ? undefined : json['payment_method_status'],
        'payment_method_owner': json['payment_method_owner'] == null ? undefined : IPaymentMethodOwnerDtoFromJSON(json['payment_method_owner']),
        'requisites': json['requisites'] == null ? undefined : IRequisitesDtoFromJSON(json['requisites']),
        'recipient_id': json['recipient_id'] == null ? undefined : json['recipient_id'],
        'payment_address': json['payment_address'] == null ? undefined : IPaymentAddressResponseDtoFromJSON(json['payment_address']),
        'activation_status': json['activation_status'] == null ? undefined : json['activation_status'],
    };
}

export function IPaymentMethodResponseDtoToJSON(json: any): IPaymentMethodResponseDto {
    return IPaymentMethodResponseDtoToJSONTyped(json, false);
}

export function IPaymentMethodResponseDtoToJSONTyped(value?: IPaymentMethodResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'payment_method_type': value['payment_method_type'],
        'is_default': value['is_default'],
        'account_id': value['account_id'],
        'payment_method_status': value['payment_method_status'],
        'payment_method_owner': IPaymentMethodOwnerDtoToJSON(value['payment_method_owner']),
        'requisites': IRequisitesDtoToJSON(value['requisites']),
        'recipient_id': value['recipient_id'],
        'payment_address': IPaymentAddressResponseDtoToJSON(value['payment_address']),
        'activation_status': value['activation_status'],
    };
}

